import React from 'react';
import cn from 'classnames';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import URL from '@/finsight/Router/urlConstants';
import { IFilling } from '@/finsight/domain/vo/Filings/Filings';
import Cell from './Cell';
import { getFile } from './helpers';

import filingsCellsStyles from './filingsCells.scss';

const getCell = ({ row: filing }: { row: IFilling }) => {
  const file = getFile(filing);

  if (file.imported) {
    const cellProps = {
      tooltip: 'Open StratMaker',
      href: '',
      content: (
        <a
          href={ `${ URL.STRATS }/${ file.fileViewId }` }
          target="_blank"
        >
          StratMaker
        </a>
      ),
    };
    return <Cell { ...cellProps } />;
  }
  return null;
};

interface IStratsLinkCellPropTypes {
  rowIndex: number,
  filing: IFilling,
}

const StratsLinkCell = ({
  rowIndex,
  filing,
}: IStratsLinkCellPropTypes) => (
  <BodyCell
    name="StratsLinkCell"
    dataTest="stratsLinkCell"
    className={ cn(filingsCellsStyles.unstyledLink, filingsCellsStyles.mainField, filingsCellsStyles.noWrap) }
    rowIndex={ rowIndex }
    rowData={ filing }
    cellCallback={ getCell }
  />
);

export default StratsLinkCell;
